/**
 * @public
 */
export class AnyExtensions {
  public static coerceNumber(value: any, nullable?: boolean): number {
    if (nullable) {
      return !isNaN(parseFloat(value as any)) && !isNaN(Number(value)) ? Number(value) : value;
    } else {
      return !isNaN(parseFloat(value as any)) && !isNaN(Number(value)) ? Number(value) : 0;
    }
  }

  public static coerceBoolean(value: any): boolean {
    return value !== null && `${value}` !== 'false';
  }

  public static coerceCssPixelValue(value: any): string {
    return value === null ? '' : typeof value === 'string' ? value : `${value}px`;
  }

  public static coerceArray<T>(value: T | Array<T>): Array<T> {
    return Array.isArray(value) ? value : [value];
  }
}
